import { cloneListOfCloneable, isSameData, isSameList } from '../../models/dto/data-model-utils.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { Voucher } from '../../models/serializable/discounts/voucher.js';
import { OpenAccessPass } from '../../models/serializable/open-access-pass/open-access-pass.js';
import { JSONUtils } from '../../utility/json-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class OrderArtifactsComponent extends Component {
  static readonly TYPE_ID: string = 'd1b0f3afa2d54b25a9811578ba0da06f';

  constructor(
    public readonly vouchers: Voucher[],
    public readonly openAccessPasses: OpenAccessPass[],
  ) {
    super();
  }

  get $typeId(): string {
    return OrderArtifactsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static empty(): OrderArtifactsComponent {
    return new OrderArtifactsComponent([], []);
  }

  static create(args: {
    vouchers: Voucher[],
    openAccessPasses: OpenAccessPass[],
  }): OrderArtifactsComponent {
    return new OrderArtifactsComponent(
        args.vouchers,
        args.openAccessPasses,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OrderArtifactsComponent {
    return this.create({
      vouchers: MapUtils.getList(
          map,
          'vouchers',
          (x) => context.fromData<Voucher>(JSONUtils.decodeRecord(x))),
      openAccessPasses: MapUtils.getList(
          map,
          'openAccessPasses',
          (x) => context.fromData<OpenAccessPass>(JSONUtils.decodeRecord(x))),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      vouchers: this.vouchers.map((x) => context.toData(x)),
      openAccessPasses: this.openAccessPasses.map((x) => context.toData(x)),
    };
  }

  clone(): this {
    return OrderArtifactsComponent.create({
      vouchers: cloneListOfCloneable(this.vouchers),
      openAccessPasses: cloneListOfCloneable(this.openAccessPasses),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.vouchers, this.vouchers, isSameData) &&
      isSameList(other.openAccessPasses, this.openAccessPasses, isSameData);
  }
}

export class OrderArtifactsComponentBuilder extends DataModelBuilder<OrderArtifactsComponent> {
  build(context: SerializationContext, map: SerializedData): OrderArtifactsComponent {
    return OrderArtifactsComponent.fromMap(context, map);
  }
}
